module.exports = __webpack_public_path__ + "static/media/Ronit.5e59a549.jpeg";